import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { Button } from "@/components/ui";
import { formatTime } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";
import { TimeSlotGroup } from "./time-picker";
interface TimeButtonProps {
  time: Date;
  isSelected: boolean;
  onClick: (time: Date) => void;
  className?: string;
  style?: React.CSSProperties;
  group?: TimeSlotGroup;
}
const TimeButton = t0 => {
  const $ = _c(17);
  const {
    time,
    isSelected,
    onClick,
    className,
    style,
    group
  } = t0;
  let t1;
  bb0: {
    if (group === TimeSlotGroup.morning) {
      t1 = "border-status-warning-text";
      break bb0;
    } else {
      if (group === TimeSlotGroup.afternoon) {
        t1 = "border-status-info-text";
        break bb0;
      } else {
        if (group === TimeSlotGroup.evening) {
          t1 = "border-border";
          break bb0;
        }
      }
    }
    t1 = "border-primary";
  }
  const hoverBorderColor = t1;
  const t2 = isSelected ? "primary" : "secondary";
  let t3;
  if ($[0] !== onClick || $[1] !== time) {
    t3 = () => onClick(time);
    $[0] = onClick;
    $[1] = time;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `hover:scale-105 hover:${hoverBorderColor} hover:shadow-lg`;
  const t5 = !isSelected && "!bg-transparent";
  let t6;
  if ($[3] !== className || $[4] !== t4 || $[5] !== t5) {
    t6 = cx("motion-preset-slide-right-sm origin-top text-nowrap text-body-lg md:text-body h-12 md:h-10 md:px-4", t4, t5, className);
    $[3] = className;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== time) {
    t7 = formatTime(time);
    $[7] = time;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7) {
    t8 = <span>{t7}</span>;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== style || $[12] !== t2 || $[13] !== t3 || $[14] !== t6 || $[15] !== t8) {
    t9 = <Button variant={t2} onClick={t3} className={t6} style={style}>{t8}</Button>;
    $[11] = style;
    $[12] = t2;
    $[13] = t3;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
export default TimeButton;